import { ActivityDataSourceInclude } from './ActivityDataSource';
export var SubcategoryInclude = {
    category: true,
    activityDataSourceMappings: {
        include: {
            calculationMethod: {
                include: {
                    type: true,
                },
            },
            activityDataSource: {
                include: ActivityDataSourceInclude,
            },
        },
    },
};
//# sourceMappingURL=Subcategory.js.map